<script setup lang="ts">
import { ref } from 'vue'
import Settings from './Settings.vue'
import Item from './Item.vue'
import { useRouter } from 'vue-router'
import { usePermissions, useToOldB, useUserInfo } from '@mp/hooks'

const { toOldB } = useToOldB()
const VITE_PUBLIC_PATH = import.meta.env.VITE_PUBLIC_PATH

const settingRef = ref<InstanceType<typeof Settings>>()
const router = useRouter()

usePermissions()

const { isAuthorized, memberRoles } = usePermissions()
const { isHeadOffice, userInfoLoading } = useUserInfo()

function handleOpenLink(name: string) {
  router.push({ name })
}

// ?跳转到进件
function handleIncoming() {
  toOldB({ url: '/?from=B&autoIn=true' })
}

// ?商户查询
function handleQuery() {
  toOldB({ url: '/?from=B&query=true' })
}
</script>

<template>
  <section id="QUICKMENU" class="bg-white px-4 py-4 pb-2 rounded-lg min-h-[108px]">
    <label class="text-base text-n-800 flex mb-3 font-medium">常用功能
      <!-- <el-button link type="primary" class="ml-auto" @click="settingRef?.open()">管理</el-button> -->
    </label>

    <div class="flex flex-wrap leading-none">
      <el-skeleton :rows="1" animated :loading="userInfoLoading">
        <template #template>
          <el-skeleton-item v-for="item in 4" :key="item" variant="text" style="height: 40px; width: 120px;" class="mr-3" />
        </template>
        <template v-if="isHeadOffice">
          <Item v-if="isAuthorized('ORDER_QUERY')" id="HEADOFFICE_QUICKMENU_ORDER_QUERY" v-track :icon="`${VITE_PUBLIC_PATH}icon/menu-1.svg`" label="交易明细查询" class="mr-3 mb-2" @click="handleOpenLink('TransactionOrder')" />
          <Item v-if="isAuthorized('BILL_TRANSACTION')" id="HEADOFFICE_QUICKMENU_BILL_TRANSACTION" v-track :icon="`${VITE_PUBLIC_PATH}icon/menu-3.svg`" label="交易对账单" class="mr-3 mb-2" @click="handleOpenLink('BillTrade')" />
          <Item v-if="isAuthorized('OFFICE_MERCHANT_QUERY')" id="HEADOFFICE_QUICKMENU_OFFICE_MERCHANT_QUERY" v-track :icon="`${VITE_PUBLIC_PATH}icon/menu-2.svg`" label="子商户管理" class="mr-3 mb-2" @click="handleOpenLink('OperateGroupMerchantSub')" />
        </template>
        <template v-else>
          <Item v-if="isAuthorized('ORDER_QUERY')" id="QUICKMENU_ORDER_QUERY" v-track :icon="`${VITE_PUBLIC_PATH}icon/menu-1.svg`" label="交易明细查询" class="mr-3 mb-2" @click="handleOpenLink('TransactionOrder')" />
          <Item v-if="isAuthorized('BILL_TRANSACTION')" id="QUICKMENU_BILL_TRANSACTION" v-track :icon="`${VITE_PUBLIC_PATH}icon/menu-3.svg`" label="交易账单" class="mr-3 mb-2" @click="handleOpenLink('BillTrade')" />
          <Item v-if="isAuthorized('SHOP_QUERY')" id="QUICKMENU_SHOP_QUERY" v-track :icon="`${VITE_PUBLIC_PATH}icon/menu-2.svg`" label="门店管理" class="mr-3 mb-2" @click="handleOpenLink('OperateStores')" />

          <!-- ?代理商才有入口 -->
          <template v-if="memberRoles?.includes('SDPPRO_AGGREGATION_AGENT')">
            <Item v-track :icon="`${VITE_PUBLIC_PATH}icon/menu-4.svg`" label="商户进件" class="mr-3 mb-2" @click="handleIncoming()" />
            <Item v-track :icon="`${VITE_PUBLIC_PATH}icon/menu-5.svg`" label="商户查询" class="mr-3 mb-2" @click="handleQuery()" />
          </template>
        </template>
      </el-skeleton>
    </div>
  </section>

  <Settings ref="settingRef" />
</template>
